import { lazy } from 'react';
import * as components from './Components';
import * as next from './Next';

const GettingStartedPage = lazy(() => import('./Guides/GettingStartedPage'));
const ChangelogPage = lazy(() => import('./ChangelogPage'));
const AccessibilityPage = lazy(() => import('./Guides/AccessibilityPage'));
const LocalizationPage = lazy(() => import('./Guides/LocalizationPage'));
const LicensePage = lazy(() => import('./LicensePage'));
const TestingPage = lazy(() => import('./Guides/TestingPage'));
const CustomizationPage = lazy(() => import('./Guides/CustomizationPage'));
const SupportedPlatformsPage = lazy(() =>
    import('./Guides/SupportedPlatformsPage')
);
const VersioningPage = lazy(() => import('./Guides/VersioningPage'));

const override = {
    UIProvider: {
        title: 'UI Provider',
        path: '/ui-provider',
    },
};

const skipSidebar = {
    // Combobox: true,
};

function mapPage(name, content, path, basePath) {
    if (override[name]) {
        return {
            title: override[name].title,
            path: override[name].path,
            content,
        };
    }

    const words = name
        .replace(/([A-Z])/g, ' $1')
        .slice(1) // remove empty space
        .split(' '); // split into words

    return {
        title: words.join(' '),
        path: path ?? `${basePath ?? ''}/${words.join('-').toLowerCase()}`,
        skipSidebar: skipSidebar[name],
        content,
    };
}

function mapPages(pages, basePath) {
    return Object.keys(pages)
        .sort((a, b) => {
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
            return 0;
        })
        .map(name => {
            return mapPage(name, pages[name], undefined, basePath);
        });
}

const items = [
    {
        title: 'Guides',
        path: '/guides',
        children: [
            mapPage('Accessibility', AccessibilityPage),
            mapPage('GettingStarted', GettingStartedPage),
            mapPage('Localization', LocalizationPage),
            mapPage('Testing', TestingPage),
            mapPage('Customization', CustomizationPage),
            mapPage('SupportedPlatforms', SupportedPlatformsPage),
            mapPage('Versioning', VersioningPage),
        ],
    },
    {
        title: 'Components',
        path: '/components',
        children: mapPages(components),
    },
    {
        title: 'Next',
        path: '/next',
        children: mapPages(next, '/next'),
    },
    mapPage('Changelog', ChangelogPage),
    mapPage('License', LicensePage),
];

export default items;
